<template>
  <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true" style="margin-top: 10%">
    <common-dialog id="contactemailDialog" :message="dialogmsg"/>
    <div class="modal-dialog modal-lg" style="min-width: 900px">
      <div class="modal-content" style="min-width: 900px">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="false">&times;</button>
          <h4 id="modalLabel" class="modal-title" style="text-align:center; font-size: 20px; color: #3e4d5c">Contact Us</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12 newa">
              <div>
                <div class="row margin-top-20 margin-left-20 margin-right-20 margin-bottom-20">
                  <div class="col-md-12">
                    <div><img src="@/assets/image/frontlogo.png" alt="UI"></div>
                    <br>
                    <h5 class="fs-13"><span class="field-color">Contact Us <a href="mailto:contact@beeftochina.com">contact@beeftochina.com</a></span></h5>
                    <h5 class="fs-13"><span class="field-color">Business Development <a href="mailto:bd@beeftochina.com">bd@beeftochina.com</a></span></h5>
                    <h5 class="fs-13"><span class="field-color">Human Resource <a href="mailto:hr@beeftochina.com">hr@beeftochina.com</a></span></h5>
                    <br>
                    <div>
                      <form role="form" name="contact">
                        <fieldset class="field-color fs-14">
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/namefinal.png" width="24" height="24"> Your Name <span class="require">*</span>
                            </label>
                            <div>
                              <input v-model="emailBody.Name" type="text" class="form-control inputstyle" name="YourName" @blur="checkUserName">
                              <span style="color:red"><span>{{ nameerror }}</span></span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/companyfinal.png" width="24" height="24"> Your Company <span class="require">*</span>
                            </label>
                            <div>
                              <input v-model="emailBody.CompanyName" type="text" class="form-control inputstyle" name="YourCompany" @blur="checkCompanyName">
                              <span style="color:red"><span>{{ companyerror }}</span></span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/phonefinal.png" width="24" height="24"> Your Phone Number <span class="require">*</span>
                            </label>
                            <div>
                              <input v-model="emailBody.Phone" type="text" class="form-control inputstyle" name="YourPhone" @blur="checkPhone">
                              <span style="color:red"><span>{{ phoneerror }}</span></span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/emailfinal.png" width="24" height="24"> Your Email <span class="require">*</span>
                            </label>
                            <div>
                              <input v-model="emailBody.Email" type="text" class="form-control inputstyle" name="YourEmail" @blur="checkEmail">
                              <span style="color:red"><span>{{ emailerror }}</span></span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/messagefinal.png" width="24" height="24"> Your Message <span class="require">*</span>
                            </label>
                            <div>
                              <textarea v-model="emailBody.Content" type="text" class="form-control inputstyle" name="YourMessage" style="min-height:80px;" @blur="checkReq"/>
                              <span style="color:red"><span>{{ helperror }}</span></span>
                            </div>
                          </div>
                        </fieldset>
                        <div class="row">
                          <div class="col-md-3 col-md-offset-9 padding-left-0">
                            <button class="btn btn-primary" data-dismiss="modal">Cancel</button>
                            <button :disabled="false" class="btn btn-danger" @click.prevent="sendMail">Send</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import CommonDialog from '@/components/CommonDialog'
export default {
  components: { CommonDialog },
  data() {
    return {
      emailBody: {
        Name: '',
        CompanyName: '',
        Phone: '',
        Email: '',
        Content: ''
      },
      nameerror: '',
      companyerror: '',
      phoneerror: '',
      emailerror: '',
      helperror: '',
      dialogmsg: ''
    }
  },
  methods: {
    sendMail() {
      if (this.isCheck()) {
        this.$store.dispatch('SetLoadingStatus', true)
        this.$store.dispatch('SendMail', this.emailBody).then(() => {
          this.dialogmsg = 'contactemailsendok'
          this.$store.dispatch('SetLoadingStatus', false)
          $('#contactemailDialog').modal({ show: true })
          this.emailBody = {}
        }).catch(() => {
          this.$store.dispatch('SetLoadingStatus', false)
        })
      }
    },
    checkUserName() {
      if (!this.emailBody.Name || !this.emailBody.Name.replace(/\s*/g, '')) {
        this.nameerror = 'Please enter your name'
        return false
      } else {
        this.nameerror = ''
        return true
      }
    },
    checkCompanyName() {
      if (!this.emailBody.CompanyName || !this.emailBody.CompanyName.replace(/\s*/g, '')) {
        this.companyerror = 'Please enter your company name'
        return false
      } else {
        this.companyerror = ''
        return true
      }
    },
    checkPhone() {
      if (!this.emailBody.Phone || !this.emailBody.Phone.replace(/\s*/g, '')) {
        this.phoneerror = 'Please enter your phone'
        return false
      } else if (!/\d+/.test(this.emailBody.Phone)) {
        this.phoneerror = 'Only numbers are allowed'
        return false
      } else {
        this.phoneerror = ''
        return true
      }
    },
    checkEmail() {
      if (!this.emailBody.Email || !this.emailBody.Email.replace(/\s*/g, '')) {
        this.emailerror = 'Please enter your email'
        return false
      } else if (!/(\S)+[@]{1}(\S)+[.]{1}(\w)+/.test(this.emailBody.Email)) {
        this.emailerror = 'Email format error'
        return false
      } else {
        this.emailerror = ''
        return true
      }
    },
    checkReq() {
      if (!this.emailBody.Content || !this.emailBody.Content.replace(/\s*/g, '')) {
        this.helperror = 'Please enter your request'
        return false
      } else {
        this.helperror = ''
        return true
      }
    },
    isCheck() {
      return this.checkUserName() && this.checkCompanyName() && this.checkPhone() && this.checkEmail() && this.checkReq()
    }
  }
}
</script>

<style scoped>
a { text-decoration: none }
a:link    { color: #E02222 }
a:visited { color: #E02222 }
a:hover   { color: #E02222 }
a:active  { color: #E02222 }
.inputstyle { border: solid 1px #e0e0e0!important }
.inputstyle:focus { border: solid 1px #e0e0e0!important }
.field-color { color: #3e4d5c!important }
.fs-13 { font-size: 13px!important }
.fs-14 { font-size: 14px!important }
</style>



// WEBPACK FOOTER //
// src/views/layout_pork_en/components/Footer/components/ContactUs/index.vue